interface BackToOriginUtils {
  link?: string;
  key?: string;
}

export default {} as BackToOriginUtils;
